import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import Tooltip from '@mui/material/Tooltip';
import { AiFillFileText } from 'react-icons/ai';
import ReactiveButton from 'reactive-button';
import { reactLocalStorage } from 'reactjs-localstorage';
import createNotification from './NotificationContainer';

const ExportWithReason = ({ data, searchedKeys, exportFile, tooltip = "Export Data" }) => {
  const [popup, setPopup] = useState({
    view: false,
    reason: '',
    data: '',
    type: '',
    error: false,
  });

  const [loading, setLoading] = useState(false);

  const main_user_type = reactLocalStorage.getObject('main_user_type', {});
  const isPopupUser = main_user_type === 1;

  const handleClick = async () => {

    if (isPopupUser) {
      if (data) {
        setPopup({ ...popup, view: true, type: 'EXPORT' });
      } else {
        createNotification('error', 'No data found');
      }
    } else {
      setLoading(true);

      await exportFile()

      setLoading(false);

    }
  };

  const submitReason = () => {
    if (!popup.reason?.trim()) {
      setPopup({ ...popup, error: true });
      return;
    }

    setLoading(true);

    if (popup.type === 'EXPORT') {
      exportFile({ comment: popup.reason })
    }


    setTimeout(() => {
      setLoading(false);
      setPopup({
        view: false,
        reason: '',
        data: '',
        type: '',
        error: false,
      });
    }, 1000);
  };

  return (
    <>
      <Tooltip title={tooltip} placement="top" disableInteractive>
      {
        
        !loading ? 
           (
            <div onClick={handleClick} role="button" className='m-1'>
              <AiFillFileText size={22} style={{ color: '#1ba1a6' }} />
            </div>
          ) : (
          <div className="spinner-border spinner-border-sm" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        )
      }
      </Tooltip>

      <Modal show={popup.view} size="lg" onHide={() => setPopup({ ...popup, view: false })}>
        <Modal.Header closeButton />
        <Modal.Body>
          <div className="detail-modal">
            <label className="form-label">Reason</label>
            <textarea
              maxLength={500}
              rows={5}
              className="form-control"
              placeholder="Enter Reason"
              value={popup.reason}
              onChange={(e) => setPopup({ ...popup, reason: e.target.value, error: false })}
            />
            {popup.error && <div className="text-danger p-2">This field is required</div>}

            <div className="hstack gap-2 justify-content-end mt-2">
              <ReactiveButton
                style={{ backgroundColor: '#b7babf' }}
                idleText="Cancel"
                onClick={() =>
                  setPopup({
                    view: false,
                    reason: '',
                    data: '',
                    type: '',
                    error: false,
                  })
                }
              />
              <ReactiveButton
                style={{ backgroundColor: '#1ba1a6' }}
                className="mr-2"
                type="button"
                buttonState={loading ? loading : 'idle'}
                idleText="Submit"
                loadingText="Loading"
                successText="Done"
                onClick={submitReason}
              />
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};





export default ExportWithReason;
